import { v4 as uuidv4 } from 'uuid';
import cookies from 'nookies';
import { NextPageContext } from 'next';

const ANON_ID_COOKIE_NAME = 'ajs_anonymous_id';

/**
 * While we still use _app.getInitialProps() we need to support generating a
 * uuid on the client side for a new user visit. For now we generate the id
 * and pass it on during the _app.getInitialProps() call, in the future we
 * should change this
 */
export const getAnonId = (
    ctx: Pick<NextPageContext, 'req' | 'res'>,
    randomIdGenerator = uuidv4
): string => {
    const allCookies = cookies.get(ctx);
    const existingAnonId = allCookies[ANON_ID_COOKIE_NAME];

    if (existingAnonId) {
        const doubleQuoteRegex = /"/g;
        return existingAnonId.replace(doubleQuoteRegex, '');
    }

    const generatedAnonId = randomIdGenerator();
    const maxAge = 365 * 24 * 60 * 60;
    const sameSite = 'lax';
    const domain = '.zoopla.co.uk';
    cookies.set(ctx, ANON_ID_COOKIE_NAME, generatedAnonId, {
        maxAge,
        sameSite,
        domain
    });

    return generatedAnonId;
};
